import {
    FETCH_OT_EMP_NOTLEFT_REQUEST,
    FETCH_OT_EMP_NOTLEFT_SUCCESS,
    FETCH_OT_EMP_NOTLEFT_FAILURE,
} from "../constants/OTEmpNotLeftConstants";

const initialState = {
    loading: false,
    data: [],
    error: null,
};

const OTEmpNotLeftReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_OT_EMP_NOTLEFT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_OT_EMP_NOTLEFT_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };

        case FETCH_OT_EMP_NOTLEFT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default OTEmpNotLeftReducer;
